import {HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {catchError, throwError} from 'rxjs';
import {NotFoundError, OrderHistoryError, UnauthorizedError} from 'app/core/components/error-page/order-history-error';

export const errorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let ohError: OrderHistoryError;
      if (error.status === 404) {
        ohError = new NotFoundError(error);
      } else if (error.status === 403) {
        ohError = new UnauthorizedError(error);
      } else {
        ohError = new OrderHistoryError({
          source: error,
        });
      }
      return throwError(() => ohError);
    })
  );
};
